import { SxProps } from '@mui/system';

export const logosWrapperDesktopStyles: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};
